export default __webpack_public_path__ + "locales/pt-BR/SMTPSettings.json?hash=b8db7dd0c12bb19f3d7a648e4d348a2a";